const { param } = require("jquery");
const { countBy } = require("lodash");

/**
 * 測定結果管理ページ用のスクリプト
 */
 if (is_route('carbon_ops.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        carbon_ops_event_set();
        carbon_ops_config_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.carbon_ops_event_set = function() {


    /*---- ページタブ切り替え時 ----*/
    // 一覧検索ボタンクリック時
    $(document).on('click', '#mode-ops-button', function() {
        // 表示モード設定
        $('input[name="mode"]').val('ops');
        // ボタン表示制御
        $(this).removeClass('button-inactive');
        $(this).addClass('button-active');
        $('#mode-co2-button').removeClass('button-active');
        $('#mode-co2-button').addClass('button-inactive');
        // 検索実行
        search(true);
    });

    // 一覧検索ボタンクリック時
    $(document).on('click', '#mode-co2-button', function() {
        // 表示モード設定
        $('input[name="mode"]').val('co2');
        // ボタン表示制御
        $(this).removeClass('button-inactive');
        $(this).addClass('button-active');
        $('#mode-ops-button').removeClass('button-active');
        $('#mode-ops-button').addClass('button-inactive');
        // 検索実行
        search(true);
    });

    // グループ会社変更時
    $(document).on('change', '#search-form-holding_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('company_id', 'section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'holding_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 会社変更時
    $(document).on('change', '.search-form-company-select', function() {
        _select.set_select(this, 'select.search-form-section-select', {'company_id': $(this).val()});
    });

    /*---- タブ切り替え時 ----*/
    $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
        var targetTab = $(e.target).attr('href');
        var mode = targetTab === '#ops-tab' ? 'ops' : 'co2';

        // Update URL without reload
        var url = new URL(window.location.href);
        url.searchParams.set('mode', mode);
        window.history.pushState({}, '', url.toString());

        // Set search_form hidden mode value
        $('#search-form input[name="mode"]').val(mode);

        // Show/hide download button based on mode
        var $downloadBtn = $('#search-form-action_download');
        if (mode === 'co2') {
            $downloadBtn.show();
        } else {
            $downloadBtn.hide();
        }

        // Remove any existing tooltips when switching tabs
        $('.tooltip').remove();
    });

    /*---- 検索条件変更時 ----*/

    // 年月切り替えスイッチ変更時（ラジオボタン）
    $(document).on('change', 'input[name="type"]', function() {
        // スイッチ変更時は即座に検索実行
        // search();
    });

    // 月選択変更時（月ピッカーの隠しフィールド）
    $(document).on('change', 'input[name="month"]', function() {
        // 月変更時は即座に検索実行
        // search();
    });

    // 月ピッカーの矢印ボタンクリック時
    $(document).on('click', '.month-picker-inputs .back, .month-picker-inputs .forward', function() {
        // 少し遅延させて月の値が更新されてから検索実行
        setTimeout(function() {
            // search();
        }, 100);
    });

    // 会社選択変更時（Select2）
    $(document).on('select2:select', '#search-form-company_id', function() {
        // 会社変更時は即座に検索実行
        // search();
    });

    // 営業所選択変更時（Select2）
    $(document).on('select2:select', '#search-form-section_id', function() {
        // 営業所変更時は即座に検索実行
        // search();
    });

    // 車両名入力完了時も検索実行
    $(document).on('blur', '#search-form-vehicle_name', function(e) {
        // search();
    });

    /*---- 検索ボタン押下時 ----*/
    $(document).on('click', '#search-form-action_search', function () {
        $(this).prop('disabled', true);
        search();
    });

    /**
     * 検索処理
     * @param {*} conditions
     * @param {*} isClear
     * @returns
     */
    function search(isClear=false)
    {   
        let datas = $('#search-form').serializeArray();
        
        let excutionData = [];
        excutionData.push('holding_id', 'company_id', 'section_id', 'type', 'mode', 'page');
        var action = $('#search-form').attr('action').replace('/list', '');
        action = _request.create_affiliation_url(action, true, datas, excutionData);
        location.href = action;
        return false;
    }


    /* ---- ツールチップ ----*/
    // Use manual tooltip handling to prevent flashing
    $(document).off('mouseenter.tooltip mouseleave.tooltip', '[data-toggle="tooltip"]');
    $(document).on('mouseenter', '[data-toggle="tooltip"]', function() {
        var $this = $(this);
        var title = $this.attr('data-original-title') || $this.attr('title');

        if (!title) return;

        // Remove any existing tooltip
        $('.tooltip').remove();

        // Create tooltip element
        var tooltip = $('<div class="tooltip fade show" role="tooltip">' +
            '<div class="arrow"></div>' +
            '<div class="tooltip-inner" style="max-width: 300px; text-align: left; white-space: pre-line;">' + title + '</div>' +
            '</div>');

        // Position tooltip
        $('body').append(tooltip);
        var offset = $this.offset();
        var tooltipHeight = tooltip.outerHeight();
        var tooltipWidth = tooltip.outerWidth();

        tooltip.css({
            position: 'absolute',
            top: offset.top - tooltipHeight - 10,
            left: offset.left + ($this.outerWidth() / 2) - (tooltipWidth / 2),
            zIndex: 1070
        });
    });
    $(document).on('mouseleave', '[data-toggle="tooltip"]', function() {
        setTimeout(function() {
            $('.tooltip').remove();
        }, 100);
    });

    
    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-config-modal]', function () {
        _modal.create(this, 'config-modal');
    });
    
}

/**
 * 設定モーダル表示時のイベント設定
 */
window.carbon_ops_config_event_set = function() {

    /*---- 稼働率算出方法の変更時 ----*/

    // 稼働率算出方法の初期表示制御
    function toggleOpsIncludeStartEndOnly() {
        var $wrapper1 = $('#ops-include-start-end-only-wrapper');
        var $wrapper2 = $('#reference-time-wrapper');

        // 要素が存在しない場合は処理を中断
        if ($wrapper1.length === 0 || $wrapper2.length === 0) {
            console.log('Modal elements not ready yet, skipping toggleOpsIncludeStartEndOnly');
            return;
        }

        var opsMode = $('input[name="ops_mode"]:checked').val();

        // If opsMode is not available from radio button, get from data attribute
        if (!opsMode) {
            opsMode = $wrapper1.data('initial-ops-mode') || '1';
        }

        console.log('toggleOpsIncludeStartEndOnly: opsMode =', opsMode);

        if (opsMode == '2') {
            // 時間単位の場合は非表示
            $wrapper1.hide();
            $wrapper2.show();
        } else {
            // 日付単位の場合は表示
            $wrapper1.show();
            $wrapper2.hide();
        }
    }

    // 初期表示時の制御（設定モーダル表示時）
    $(document).on('shown.bs.modal', '#config-modal', function() {
        // モーダルが完全に表示された後に制御を実行
        console.log('Modal shown.bs.modal event triggered');
        toggleOpsIncludeStartEndOnly();
    });

    // モーダルのコンテンツが動的に読み込まれる場合の対応
    $(document).on('DOMNodeInserted', '#config-modal .modal-body', function() {
        // DOM要素が挿入された後に制御を実行
        console.log('Modal content DOMNodeInserted event triggered');
        setTimeout(function() {
            toggleOpsIncludeStartEndOnly();
        }, 100);
    });

    // より確実にモーダルコンテンツの読み込みを検知
    function waitForModalContent() {
        var checkInterval = setInterval(function() {
            var $wrapper1 = $('#ops-include-start-end-only-wrapper');
            var $wrapper2 = $('#reference-time-wrapper');
            var $opsMode = $('input[name="ops_mode"]');

            if ($wrapper1.length > 0 && $wrapper2.length > 0 && $opsMode.length > 0) {
                console.log('Modal content elements found, executing toggleOpsIncludeStartEndOnly');
                clearInterval(checkInterval);
                toggleOpsIncludeStartEndOnly();
            }
        }, 50);

        // 5秒後にタイムアウト
        setTimeout(function() {
            clearInterval(checkInterval);
        }, 5000);
    }

    // モーダル表示時にコンテンツ待機を開始
    $(document).on('click', '[data-config-modal]', function() {
        console.log('Config modal button clicked, starting content wait');
        setTimeout(waitForModalContent, 100);
    });

    // 稼働率算出方法変更時の制御
    $(document).on('change', 'input[name="ops_mode"]', function() {
        toggleOpsIncludeStartEndOnly();
    });

    /*---- 稼働率基準日の曜日選択クリアボタン ----*/

    // クリアボタン押下時
    $(document).on('click', '[id$="-clear-standard-days"]', function() {
        // すべての standard_days チェックボックスをクリア
        $('input[name="standard_days[]"]').each(function() {
            $(this).prop('checked', false);
            // ラベルのactiveクラスも削除（Bootstrap button group用）
            $(this).closest('label').removeClass('active');
        });

        // Bootstrap button groupの場合、data-toggle="buttons"の状態もリセット
        $('.week-check input[type="checkbox"]').trigger('change');
    });

    /*---- 基準時間の入力制御 ----*/

    // 基準時間の入力値検証
    function validateReferenceTime() {
        var startTime = $('#carbon_ops-config-modal-reference_start_time').val();
        var endTime = $('#carbon_ops-config-modal-reference_end_time').val();

        if (startTime && endTime) {
            var start = new Date('1970-01-01T' + startTime + ':00');
            var end = new Date('1970-01-01T' + endTime + ':00');

            if (start >= end) {
                // alert('終了時間は開始時間より後に設定してください。');
                return false;
            }
        }
        return true;
    }

    // 基準時間の入力時の検証
    $(document).on('change', '#carbon_ops-config-modal-reference_start_time, #carbon_ops-config-modal-reference_end_time', function() {
        validateReferenceTime();
    });

    /*---- 保存時 ----*/
    $(document).off('click', '[data-config-save-modal="#carbon_ops-config-modal"]');
    $(document).on('click', '[data-config-save-modal="#carbon_ops-config-modal"]', function () {
        if (validateReferenceTime()) {
            _modal.submit(this, 'config-save-modal');
        }
    });

}